import axiosPrivateInstance from 'middlewares/AxiosInstance'

// Flags são opcionais — a action já cai para `false` em caso de erro. A chamada
// é marcada para não entrar no fluxo de refresh/redirect do interceptor: sendo
// disparada no boot com um token possivelmente velho, ela derrubaria a sessão e
// recarregaria a tela de login em loop.
const fetchFeatureFlags = () => axiosPrivateInstance.get('/feature-flags', { skipAuthRetry: true })

export default { fetchFeatureFlags }
